import * as React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { OptionsObject, withSnackbar, WithSnackbarProps } from 'notistack';
import { removeSnackbar } from '@pec/aion-ui-core/actions/removeSnackbar';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { SnackbarCloseReason } from '@material-ui/core/Snackbar';
import { ThunkDispatch } from 'redux-thunk';

const mapStateToProps = (state: CommonRootState) => state.snackbars;

const mapDispatchToProps = (dispatch: ThunkDispatch<CommonRootState, null, RootActions>) => ({
  removeSnackbar: (key: number) => dispatch(removeSnackbar(key))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & WithSnackbarProps;

class Notifier extends React.Component<Props> {
  displayed: number[] = [];

  storeDisplayed = (id: number) => {
    this.displayed = [...this.displayed, id];
  };

  dismissSnackbar = (snackbarKey: string | number | undefined, reduxSnackbarKey: number | undefined) => (
    _event: React.MouseEvent
  ) => {
    this.props.closeSnackbar(snackbarKey);

    if (reduxSnackbarKey) {
      this.props.removeSnackbar(reduxSnackbarKey);
    }
  };

  componentDidUpdate() {
    const { snackbars = [] } = this.props;

    snackbars.forEach(({ key, message, options = {} }) => {
      if (key && this.displayed.includes(key)) return;

      this.props.enqueueSnackbar(message, {
        persist: options.persist && !options.autoHideDuration ? true : false,
        transitionDuration: {
          enter: 500,
          exit: 200
        },
        autoHideDuration: !options.persist ? 3000 : undefined,
        action: snackbarKey => (
          <CloseIcon style={{ cursor: 'pointer' }} onClick={this.dismissSnackbar(snackbarKey, key)} />
        ),
        onClose: (event: React.SyntheticEvent, reason: SnackbarCloseReason) => {
          if (options.onClose) {
            options.onClose(event, reason);
          }

          if (key) {
            this.props.removeSnackbar(key);
          }
        },
        ...(options as OptionsObject)
      });

      if (key) {
        this.storeDisplayed(key);
      }
    });
  }

  render() {
    return null;
  }
}

export const NotifierContainer = withSnackbar(connect(mapStateToProps, mapDispatchToProps)(Notifier));
